import { phasenFuerTyp, aktuellePhase, hatPhasenleiste, phaseIndex, phaseLabel } from '@pilot-hub/ui'
import { Check } from 'lucide-react'

/** Kleine Anzeige, in welcher Phase der Einsatz gerade ist (gesetzt von der Führung) – nur lesend */
export function PhasenAnzeige({ einsatz }: { einsatz?: { typ?: string | null; status?: string | null; phase?: string | null } | null }) {
  if (!hatPhasenleiste(einsatz?.typ)) return null   // Übungen (UEBUNG) haben keine Phasenleiste
  const phase = aktuellePhase(einsatz)
  const idx = phaseIndex(phase, einsatz?.typ)
  return (
    <div data-testid="phasen-anzeige" className="flex flex-wrap items-center gap-x-3 gap-y-2 rounded-xl border border-dark-border bg-dark-bg-tertiary/40 px-3 py-2">
      <span className="text-sm text-dark-text-muted">Phase:</span>
      {phase ? (
        <ol className="flex flex-wrap items-center gap-1.5">
          {phasenFuerTyp(einsatz?.typ).map((p, i) => (
            <li key={p.key} aria-current={i === idx ? 'step' : undefined}
              className={`flex items-center gap-1 rounded-full px-2.5 py-1 text-xs ${
                i === idx ? 'bg-primary-600 font-semibold text-white' : i < idx ? 'bg-green-500/15 text-green-300' : 'bg-dark-border/50 text-dark-text-muted'}`}>
              {i < idx && <Check className="h-3 w-3" />}{p.label}
            </li>
          ))}
        </ol>
      ) : (
        <span className="text-sm text-dark-text-muted">noch keine Phase gesetzt (die Führung setzt sie)</span>
      )}
      <span className="sr-only">Aktuelle Phase: {phaseLabel(phase)}</span>
    </div>
  )
}
